import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";

import axios from "../../helpers/axios";
import {
  GeneralTable,
  Layout,
  Notification,
  ScreenHeading,
} from "../../webtracking/components";
import { UserTypes } from "../commons";

const useUsersScreen = () => {
  const [users, setUsers] = useState([]);
  const [message, setMessage] = useState("");
  const [isLoading, setLoading] = useState(true);

  const loadUsers = () => {
    setLoading(true);

    axios
      .get("/api/user/")
      .then(({ data }) => {
        // @TODO implement paginator
        setUsers(data.results);
      })
      .catch((error) => {
        setMessage("No se pudo completar la petición.");
        console.error(error);
      })
      .then(() => {
        setLoading(false);
      });
  };

  useEffect(() => {
    loadUsers();
  }, []);

  const history = useHistory();

  const handleUserClick = (user) => {
    history.push(`/users/${user.id}`);
  };

  return {
    users,
    message,
    isLoading,
    handleUserClick,
  };
};

const UsersScreen = () => {
  const { isLoading, message, users, handleUserClick } = useUsersScreen();

  const cols = [
    {
      label: "Nombre de usuario",
      render: (row) => <span>{row.username}</span>,
    },
    {
      label: "Nombres",
      render: (row) => <span>{row.first_name}</span>,
    },
    {
      label: "Apellidos",
      render: (row) => <span>{row.last_name}</span>,
    },
    {
      label: "Correo electrónico",
      render: (row) => <span>{row.email}</span>,
    },
    {
      label: "Tipo de usuario",
      render: (row) => <span>{UserTypes[row.user_type]}</span>,
    },
  ];

  return (
    <Layout>
      <ScreenHeading title="Usuarios" />
      <div className="container has-background-light p-6 mt-5">
        <Notification message={message} />
        <GeneralTable
          rowKey="id"
          isLoading={isLoading}
          rows={users}
          cols={cols}
          onRowClick={handleUserClick}
        />
      </div>
    </Layout>
  );
};

export default UsersScreen;
